export default __webpack_public_path__ + "static/media/cloud2.5fd231ef.png";